'use client'

import React from 'react'

export interface MainNavigationProps {
    children: React.ReactNode
}

export const MainNavigation = ({ children }: MainNavigationProps) => {
    return <div className="main-navigation inline-flex shrink-0">{children}</div>
}
